import React from "react"
import { Button, Input } from 'antd'
import agentPayments from "@services/agentPayments"

class BulkPay extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            list: [],
            invalid: [],
            loading: false,
            response: '',
            error: ''
        }
    }

    handleInput = (e) => {
        let { value } = e.target
        let list = value.split('\n')
        
        let invalid = []
        list = list.reduce((acum, cur) => {
            let num = Number(cur)
           
            if (!isNaN(num) && typeof num == 'number') acum.push(num)
            else invalid.push(cur)
            return acum
        }, [])
        this.setState({ list, invalid })
    }

    submit = () => {

        const { list: agentIds } = this.state

        this.setState({ loading: true, response: '', error: '' }, () => {
            agentPayments.payAgentList({ agentIds })
            .then(({ data: response }) => {
                this.setState({ response })
            })
            .catch((error) => {
                console.log('error', error);
                console.log('error response', error.response.data);
                this.setState({ error: error.response.data })
            })
            .finally(() => {
                this.setState({ loading: false })
            })
        })
        
    }

    render() {
        const { error, response, invalid } = this.state
        return (
            <div style={{ ...styles.wrapper }}>
                <div style={{ ...styles.container }}>
                    <span style={{ ...styles.title }}>{"כותרת"}</span>
                    <span style={{ ...styles.subTitle }}>{"יש להזין מזהי סוכנים עם רווח שורה בין האחד לאחר"}</span>
                    <Input.TextArea onChange={this.handleInput} style={{ ...styles.input }}/>
                    <Button onClick={this.submit} style={{ ...styles.button }}>{"שליחה"}</Button>
                    {invalid.length > 0 ?
                        <div style={{ ...styles.messageBlock }}>
                            <span style={{ ...styles.messageTitle }}>{'מזהים לא תקינים (לא ישלחו לעדכון):'}</span>
                            <p>{JSON.stringify(invalid)}</p>
                        </div> : ''}
                </div>
                <div style={{ ...styles.messageContainer }}>
                    {response ? 
                        <div style={{ ...styles.response, ...styles.messageBlock }}>

                            <div style={{ ...styles.messageBlock }}>
                                <span style={{ ...styles.messageTitle }}>{`מספר סוכנים עבורם התבצע עדכון: ${response.affectedRows}`}</span>
                            </div>

                            <div style={{ ...styles.messageBlock }}>
                                <span style={{ ...styles.messageTitle, color: 'red' }}>{`מזהי סוכנים עבורם לא התבצע עדכון:`}</span>
                                <p>{JSON.stringify(response.failedArray)}</p>
                            </div>

                        </div> : ''}

                    {error ?
                        <div style={{ ...styles.error, ...styles.messageBlock }}>
                            <span style={{ ...styles.messageTitle }}>{"אירעה שגיאה:"}</span>
                            <p>{error}</p>
                        </div> : ''}
                </div>
            </div>
        )
    }
}


const styles = {
    wrapper: { display: 'flex' },
    container: { display: 'flex', flexDirection: 'column' },
    title: { fontSize: '18px' },
    subTitle: { fontSize: '14px' },
    input: { width: '300px', height: '180px' },
    button: { width: '88px', margin: '14px 0 20px', alignSelf: 'center' },
    messageContainer: { alignSelf: 'center', marginRight: '100px', maxHeight: '196px', overflow: 'auto' },
    response: { display: 'flex', flexDirection: 'column' },
    error: { color: 'red' },
    messageTitle: { fontSize: '16px' },
    messageBlock: { display: 'flex', flexDirection: 'column', marginBottom: '20px' }
}

export default BulkPay

